import React from 'react'
import {
  Button as CoreButton,
  Modal,
  Timeline,
} from '@surecompanies/core_components'
import { Stack, TextColors, Typography, Button } from '@sureco/design-system'
import { LoadingOutlined } from '@ant-design/icons'
import useAssistedPayrollDetail from './hooks/useAssistedPayrollDetail'
import { useDownloadArtifactReport } from './hooks/useDownloadArtifactReport'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import { usePermission } from 'enrollment-platform/rbac/usePermission'

export default function PayrollDetailModal({ isOpen, onCancel, id }) {
  const { isPending, data, error } = useAssistedPayrollDetail(id)
  const { downloadArtifactCSV, artifactId, csvName } =
    useDownloadArtifactReport({
      data,
    })
  const { allowed: canManageUsRestrictedData } = usePermission(
    RbacActions.Manage,
    RbacSubjects.UsRestrictedData
  )

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={
        <Stack direction="row" justify="center" space={10}>
          {artifactId && (
            <CoreButton
              type="primary"
              color="primary"
              disabled={!canManageUsRestrictedData}
              onClick={() => downloadArtifactCSV(id, artifactId)}
            >
              Download {csvName}
            </CoreButton>
          )}
          <Button type="flat" variant="primary" onClick={onCancel}>
            Close
          </Button>
        </Stack>
      }
    >
      {error && (
        <Typography size={16} color={TextColors.secondary}>
          {error.message || 'Error fetching payroll details'}
        </Typography>
      )}
      {isPending && <LoadingOutlined />}
      <Stack space={20}>
        <Typography size={20} color={TextColors.primary}>
          Payroll Details
        </Typography>
        {data.length > 0 ? (
          <Timeline mode="left" items={data} />
        ) : (
          <Typography size={16} color={TextColors.secondary}>
            No details found
          </Typography>
        )}
      </Stack>
    </Modal>
  )
}
